/**
 *
 * Solutions UI
 *
 * User Interface for the solutions single template
 */

const $       = require( 'jquery' );


var SolutionsUI = function(el){

  //cache some elements
  this.$el    = $(el);
  this.$controls   = this.$el.find( '.itbl-c-solutions__controls' );
  this.$panelTarget = this.$el.find( '[data-panel-trigger]' );
  this.$panels  = this.$el.find( '.panel-target' );
  this.$contentWrapper = this.$el.find( '.itbl-c-solutions__content-wrapper' );
  this.$switchControls = this.$el.find( '[data-trigger-controls]' );

  //default scroll settings - note tho -- we need to calculate the height of the sticky menu each time smooth scroll runs
  this.scrollSettings = {
    threshold: 50,
    offset: 110,
    animationDuration: 550
  };


  this.init();
};

SolutionsUI.prototype.init = function(){
  // do something
  this.setWrapper();

  this.events();
};

SolutionsUI.prototype.events = function(){

  this.$panelTarget.on( 'click', this.event__toggleControlsClass.bind(this) );
  this.$switchControls.on( 'click', this.event__triggerPrimaryControls.bind(this) );

  $(window).on('changed.zf.mediaquery', (event, newSize, oldSize)=> {

    this.setWrapper();

  } );

};

SolutionsUI.prototype.event__toggleControlsClass = function(event){

  // Follow the link if it does not point to an anchor.
  if (!$(event.currentTarget).is('a[href^="#"]')) return;

  event.preventDefault();

  const arrival = event.currentTarget.getAttribute('href');
  const sides = {
    left  : -100,
    right  : 100,
    center  : 0
  };

  //get the current target element and attrs
  const $targetControl   = $( event.currentTarget );
  const $targetText    = $targetControl.find( '.itbl-c-solutions__control-text' );
  const $targetPanel    = this.$el.find( arrival );
  const $targetSide    = (typeof $targetPanel.data( 'panel-side' ) !== 'undefined' ) ? $targetPanel.data( 'panel-side' ) : 'center';

  //this is the other control that will be rendered inactive
  const $notControls     = this.$panelTarget.not( $targetControl );
  const $notControlsText   = $($notControls).find( '.itbl-c-solutions__control-text' );
  const $notTargetPanel  = this.$el.find( $notControls.attr('href') );
  const $notTargetSide   = ( typeof $notControls.data( 'panel-side' ) !== 'undefined' ) ? $notControls.data( 'panel-side' ) : 'center' ;
  var tl;

  function controlsToggle(){

    //add the inactive class
    $notControls
      .removeClass( 'control--active' )
      .addClass( 'control--disabled');

    //add the active class to target
    $targetControl
      .removeClass( 'control--disabled' )
      .addClass( 'control--active' );
  }

  function activeText(){
    $targetText
      .removeClass( 'control-text--disabled' )
      .addClass( 'control-text--active' );


  }

  function disableText(){
    $notControlsText
      .removeClass( 'control-text--active' )
      .addClass( 'control-text--disabled' );
  }

  function contentToggle(){

    $notTargetPanel
      .removeClass( 'content-is-active' )
      .addClass( 'content-is-inactive' );

    $targetPanel
      .removeClass( 'content-is-inactive' )
      .addClass('content-is-active' )

  }


  //check to make sure the timelinemax isn't running already
  if( tl && tl.isActive() ){
    tl.progress(1);

  }

  if( ! $( $targetPanel ).hasClass( 'content-is-active' ) ){

    tl  = new TimelineMax();
    tl
      .addLabel('togglePanel&Text')
      .call( disableText, null, null, 'togglePanel&Text' )
      .to( $notTargetPanel, .2, {autoAlpha : 0, scale : .97 }, 'togglePanel&Text' )
      .set( $targetPanel, { xPercent: sides[$targetSide], scale : 1  } )

      .addLabel( 'toggleLabel' )
      .call( contentToggle )

      .addLabel( 'contentToggle' )
      .call( controlsToggle )
      .call( activeText, null, null, '+=.25' )

      .to( $targetPanel, .3, {autoAlpha : 1, xPercent: 0, scale : 1, ease: Power4.easeInOut } );

  }else{

    controlsToggle();
    disableText();
  }

  var slick = $('.js-layout-slider')[0];

  if( slick ){

    slick.slick.refresh();

  }


};

SolutionsUI.prototype.setWrapper = function(){

  // Get an array of all element heights
  var elementHeights = this.$panels.map(function() {
    return $(this).height();
  }).get();

  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var minHeight = ( Math.min.apply(null, elementHeights) - 500 );

};

SolutionsUI.prototype.event__triggerPrimaryControls = function( event ){

  // Follow the link if it does not point to an anchor.
  if (!$(event.currentTarget).is('a[href^="#"]')) return;

  event.preventDefault();

  const arrival = $( event.currentTarget.getAttribute('href') );

  //smooth scroll to the category toggle
  Foundation.SmoothScroll.scrollToLoc( arrival, this.scrollSettings );

  //Makes sense to just trigger the category toggle
  arrival.trigger( 'click' );
};


$(document).ready(function(){
  $('.itbl-c-solutions__wrapper').each(function(){
    new SolutionsUI(this);
  });

});
